/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 7/8/13
 * Time: 2:00 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Marionette = require("marionette");
    var Template = require("templates/top-level-menu/topLevelMenu.tmpl");
    var Button = require("ui/button/Button");
    var Ellipsis = require("ui.plugins/ellipsis");
    var TopLevelMenuItemListView = require("views/top-level-menu/TopLevelMenuItemListView");
    var TopLevelMenuItemView = require("views/top-level-menu/TopLevelMenuItemView");
    var TopLevelMenuStatusListView = require("views/top-level-menu/TopLevelMenuStatusListView");
    var TopLevelMenuStatusItemView = require("views/top-level-menu/TopLevelMenuStatusItemView");

    require("ui.plugins/jquery.ba-outside-events");

    /**
     * The structure of this view is as follows:
     *
     * - header
     * - TopLevelMenuStatusListView (extends CollectionView, itemview: TopLevelMenuStatusItemView, collection of TopLevelMenuStatusModel)
     * - TopLevelMenuItemListView   (extends CollectionView, itemview: TopLevelMenuItemView, collection of TopLevelMenuItemModel)
     * - footer
     */
    var TopLevelMenu = Marionette.ItemView.extend({
        template: Template,
        ui: {
            topLevelMenu: ".top-level-menu",
            switch: ".top-level-menu-switch",
            statusListContainer: ".top-level-menu-status-list-container",
            itemListContainer: ".top-level-menu-item-list-container",
            soundButton: ".top-level-menu-sound-button",
            authButton: ".top-level-menu-auth-button" // login or logout button
        },
        events: {
            "click .top-level-menu-switch": "_onSwitchClicked",
            "click .top-level-menu-sound-button": "_onSoundButtonClicked",
            "clickoutside": "_handleOutsideClick"
        },
        customTemplateHelpers: function() {
            return {
                accountId: LE.sessionManager.isAuthenticated() ? LE.sessionManager.getAccountId() : "",
                authItemText: this._getAuthenticationItemText(),
                soundButtonTooltip: this._getSoundButtonTooltip(),
                soundEnabled: LE.soundController.isEnabled()
            };
        },
        modelEvents: {
            "change config.userId": "_onUserIdChanged"
        },
        uiComponents: {
            statusList: {
                type: TopLevelMenuStatusListView,
                options: {
                    el: "view.ui.statusListContainer",
                    collection: "view.statusCollection",
                    LE: "view.LE"
                },
                events: {
                    "item:click": "_hideMenu"
                }
            },
            itemsList: {
                type: TopLevelMenuItemListView,
                options: {
                    el: "view.ui.itemListContainer",
                    collection: "view.menuCollection"
                },
                events: {
                    "item:click": "_hideMenu"
                }
            },
            authButton: {
                type: Button,
                options: {
                    el: "view.ui.authButton",
                    permutation: Button.PERMUTATION.LINK
                },
                events: {
                    "click": "_onAuthButtonClicked"
                }
            }
        },
        initialize:function(options){
            this.LE = options.LE;
            this.statusCollection = options.statusCollection;
            this.menuCollection = options.menuCollection;
            this.isSocketConnected = false;

            if(!this.LE.sessionManager.isAuthenticated()) {
                this.model.set("config.loginName", this.LE.translator.translate("LEFramework.userBarMenu.menuItem.login"));
            }

            this.listenTo(this.LE.soundController, "change", this._onSoundStateChange);
            if (this.LE.LEWebAgent) {
                this.LE.LEWebAgent.channel.on("onAMSConnectionStatus", _.bind(function (data) { //TODO (Omar): use crossModule
                    this.connectSocket(data);
                }, this));
            }
        },

        onRender: function () {
            this.isRendered = true;
        },
        // Show mute button only to authenticated users
        onShow: function() {
            this._handleSoundButtonAppearance();
        },

        connectSocket: function (data) {
            this.isSocketConnected = data.connected;
        }   ,

        _handleSoundButtonAppearance: function() {
            if(this.LE.sessionManager.isAuthenticated()) {
                this.ui.soundButton.removeClass("hide");
            }
        },

        _getAuthenticationItemText: function () {
            var key = this.LE.sessionManager.isAuthenticated() ? "logout" : "login";
            return this.LE.translator.translate("LEFramework.userBarMenu.menuItem." + key);
        },
        _getSoundButtonTooltip: function(isEnabled) {
            if(_.isUndefined(isEnabled)) {
                isEnabled = this.LE.soundController.isEnabled();
            }
            return this.LE.translator.translate(
                "LEFramework.userBarMenu.footer.soundButton.tooltip." + (isEnabled ? "on" : "off"));
        },

        _onAuthButtonClicked: function() {
            this._hideMenu();
            var authenticated = this.LE.sessionManager.isAuthenticated();
            if (!authenticated) {
                // Remove the outerRoute so it will not be processed and added to login redirect
                this.LE.loginInfo.outerRoute = "";
            }
            this.LE.logout(authenticated);
        },
        _onSoundButtonClicked: function(){
            this._hideMenu();
            this.LE.soundController.toggleSound();
        },
        _onSoundStateChange: function(model) {
            this._refreshSoundButton(model.get("enabled"));
        },
        _refreshSoundButton: function(isEnabled) {
            this.ui.soundButton.toggleClass("sound-enabled", isEnabled);
            var soundButtonTooltip = this._getSoundButtonTooltip(isEnabled);
            this.ui.soundButton.attr("title", soundButtonTooltip);
            this.ui.soundButton.attr("tooltip-text", soundButtonTooltip); // to handle the case of tooltip already visible during change
        },
        _onSwitchClicked: function () {
            this._getShiftStatusIndicator();
            this.ui.topLevelMenu.fadeToggle(200, _.bind(function() {
                if (this.ui.topLevelMenu.is(":visible")) {
                    _.defer(_.bind(function(){
                        Ellipsis.handleNow(this);
                    }, this));
                }
            }, this));
        },

        _getShiftStatusIndicator: function() {
            var siteSettingsManualShiftStatusModel = this.LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getSiteSettingsManualShiftStatusModel);
            siteSettingsManualShiftStatusModel.fetch({
                success: _.bind(function(model, response, options) {
                    if (model.getValue() === "true") {
                        this._showManualShiftStatusIndicator();
                    }
                    else {
                        this._hideManualShiftStatusIndicator();
                    }
                }, this),
                error: _.bind(function() {
                    this._hideManualShiftStatusIndicator();
                }, this)
            });
        },

        _showManualShiftStatusIndicator: function() {
            if (this.isSocketConnected) {
                this.LE.crossModule("webagent",
                    this.LE.media.actions.command,
                    this.LE.mediaCodes.webAgent.commands.getBrandProfile,
                    {
                        brandId: this.LE.sessionManager.getAccountId(),
                        success: _.bind(function (data) {
                    var online = this._isShiftStatusOnline(data.delay.tillWhen);
                    if (online) {
                        this.LE.menuItems.ShiftStatus.set("indicatorText", this.LE.translator.translate("LEFramework.userBarMenu.item.shiftStatus.online"));
                        this.LE.menuItems.ShiftStatus.set("indicatorClass", "green");
                    } else {
                        this.LE.menuItems.ShiftStatus.set("indicatorText", this.LE.translator.translate("LEFramework.userBarMenu.item.shiftStatus.off.hours"));
                        this.LE.menuItems.ShiftStatus.set("indicatorClass", "red");
                    }
                        }, this)
                    });
            } else {
                //logger.info("The webSocket isn't connected yet, cannot show an indication if the agent should be online/offline");
            }
        },
        _hideManualShiftStatusIndicator: function() {
            this.LE.menuItems.ShiftStatus.set("indicatorText", "");
            this.LE.menuItems.ShiftStatus.set("indicatorClass", "");
        },

        //TODO: use isExpired
        _isShiftStatusOnline: function(shiftStartTime) {
            var now = (new Date()).getTime();
            if (now >= shiftStartTime) {
                return true;
            } else {
                return false;
            }
        },

        _handleOutsideClick: function () {
            if (this.ui.topLevelMenu.is(":visible")) {
                this.ui.topLevelMenu.fadeOut(200);
                this.uiComponents.statusList.closeCustomReasons();
            }
        },
        _onUserIdChanged: function() {
            if(!this.isRendered) {
                return;
            }

            this.ui.switch.text(this.model.get("config.loginName"));
        },
        _hideMenu: function() {
            this.ui.topLevelMenu.fadeOut(100);
            this.uiComponents.statusList.closeCustomReasons();
        }
    });

    return TopLevelMenu;
});

